import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import cfg from '../store/config';
import {isActiveToken} from '@/mixins/auth';

const Login = () => import(/* webpackChunkName: "auth" */ '../views/Login/Login.vue');
const Home = () => import(/* webpackChunkName: "app-shell" */ '../views/Home/Index.vue');
const Deposits = () => import(/* webpackChunkName: "deposits" */ '../views/Deposits/Deposits.vue');
const Withdraws = () => import(/* webpackChunkName: "withdraws" */ '../views/Withdraws/Withdraws.vue');
const Wallets = () => import(/* webpackChunkName: "wallets" */ '../views/Wallets/Wallets.vue');
const AmlReports = () => import(/* webpackChunkName: "wallets" */ '../views/Wallets/AmlReports.vue');
const Users = () => import(/* webpackChunkName: "users" */ '../views/Users/List.vue');
const Settings = () => import(/* webpackChunkName: "settings" */ '../views/Settings/Settings.vue');


Vue.use(Router);

const ifAuthenticated = (to, from, next) => {
  const role = store.getters['user/getRole'];
  if (role && to.meta && to.meta.access) {
    const defaultRoute = role === 'client' ? '/withdraws' : '/wallets';
    if (!to.meta.access.includes(role)) {
      next(defaultRoute);
      return;
    }
  }
  if (isActiveToken(store.getters['user/getToken'])) {
    next();
    return;
  }
  next('/login');
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      beforeEnter: ifAuthenticated,
      component: Home,
      children: [
        {
          path: '',
          beforeEnter: ifAuthenticated,
          component: Wallets,
          meta: {
            access: ['superadmin', 'support'],
            title: 'Кошельки',
          }
        },
        {
          path: 'deposits',
          name: 'Deposits',
          beforeEnter: ifAuthenticated,
          component: Deposits,
          meta: {
            access: ['superadmin'],
            title: 'Пополнения',
          }
        },
        {
          path: 'withdraws',
          name: 'Withdraws',
          beforeEnter: ifAuthenticated,
          component: Withdraws,
          meta: {
            access: ['superadmin', 'support', 'client'],
            title: 'Выводы',
          }
        },
        {
          path: 'wallets',
          name: 'Wallets',
          beforeEnter: ifAuthenticated,
          component: Wallets,
          meta: {
            access: ['superadmin', 'support'],
            title: 'Кошельки',
          }
        },
        {
          path: 'wallets/:address/aml-reports',
          name: 'AmlReports',
          beforeEnter: ifAuthenticated,
          component: AmlReports,
          meta: {
            access: ['superadmin'],
            title: 'История AML-проверок',
          }
        },
        {
          path: 'users',
          name: 'Users',
          beforeEnter: ifAuthenticated,
          component: Users,
          meta: {
            access: ['superadmin'],
            title: 'Пользователи',
          }
        },
        {
          path: 'settings',
          name: 'Settings',
          beforeEnter: ifAuthenticated,
          component: Settings,
          meta: {
            access: ['superadmin'],
            title: 'Настройки',
          }
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Авторизация',
      }
    },
  ],
});

let DEFAULT_TITLE = cfg.sitePrefix || '';
if (DEFAULT_TITLE) {
  DEFAULT_TITLE += ' - ';
}
router.afterEach((to) => {
  Vue.nextTick(() => {
    if (to.meta.title) {
      document.title = `${DEFAULT_TITLE}${to.meta.title}`;
    } else {
      if (DEFAULT_TITLE) {
        document.title = DEFAULT_TITLE;
      } else {
        document.title = 'Frontend';
      }
    }
    const mainContent = document.getElementById('main-content');
    if (mainContent) mainContent.focus({ preventScroll: true });
  });
});

export default router;
